const initPhotoVideoGalleryWidget = () => {
    const widgetAttribute = "[data-photo-video-gallery-widget]";
    const photoVideoGalleryWidget = document.querySelector(widgetAttribute);
    if (photoVideoGalleryWidget) {
        const config = new CarouselConfig();
        config.sliderSelector = `${widgetAttribute} [data-slider]`;
        config.cellAlign = CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.showArrows = false;
        config.activateCustomButtons = true;
        config.showDots = false;
        config.groupCells = false;
        config.adaptiveHeight = window.innerWidth < 767 ? true : false;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
        createdCarouselsArray.forEach(carousel => {
            //show video when user clicks on a play button
            const playButtonArray = document.querySelectorAll(`${config.sliderSelector} [data-play-button]`);
            playButtonArray.forEach(playButton => {
                playButton.addEventListener("click", () => {
                    //@ts-ignore
                    const video = playButton.closest("[data-video-component]").querySelector("[data-video]");
                    const videoUrl = video.querySelector("source").getAttribute("src");
                    const queryForAlreadyCreatedIframe = document.querySelector(`iframe[src="${videoUrl}"]`);
                    //check if iframe has already been generated
                    if (videoUrl && !queryForAlreadyCreatedIframe) {
                        //create iframe
                        const iframe = document.createElement('iframe');
                        // assign url
                        iframe.setAttribute('src', videoUrl);
                        //set various useful attributes
                        iframe.frameBorder = "0";
                        iframe.allowFullscreen = true;
                        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
                        iframe.width = (window.innerWidth - 100).toString();
                        iframe.height = (window.innerHeight - 100).toString();
                        //create iframe container
                        const iframeContainer = document.createElement('div');
                        //add class
                        iframeContainer.classList.add("iframe-container", "active");
                        //add title
                        iframeContainer.title = "Click to exit";
                        //append close icon to its container
                        iframeContainer.innerHTML = `<svg class="close-icon" fill="#FFFFFF" width="32" height="26" viewBox="0 0 32 26"  xmlns="http://www.w3.org/2000/svg">
                                                    <rect width = "32.345" height = "2.42587" transform = "matrix(0.699565 -0.714569 0.699565 0.714569 4 23.6802)" />
                                                    <rect width="32.345" height = "2.42587" transform = "matrix(-0.699565 -0.714569 0.699565 -0.714569 26.6274 25.125)" />
                                                </svg>`;
                        //append iframe to its container
                        iframeContainer.appendChild(iframe);
                        //insert iframecontainer to body
                        document.body.appendChild(iframeContainer);
                        //remove active class if user clicks outside
                        iframeContainer.addEventListener("click", () => {
                            iframeContainer.classList.remove("active");
                            iframe.setAttribute('src', "");
                        });
                        //scroll to iframe
                        iframe.scrollIntoView({ "block": "center", "inline": "center" });
                    }
                    else {
                        //add active to iframe's container
                        const iframe = document.createElement('iframe');
                        // assign url
                        iframe.setAttribute('src', videoUrl);
                        queryForAlreadyCreatedIframe.parentElement.classList.add("active");
                        //scroll to already created iframe
                        queryForAlreadyCreatedIframe.scrollIntoView({ "block": "center", "inline": "center" });
                    }
                });
            });
        });
    }
};
